import apiClient from '../config/api';

const lineService = {
  /**
   * Get all lines for the current tenant
   * @param {number} plantId - Optional plant ID to filter by
   * @returns {Promise} Array of lines
   */
  getAllLines: async (plantId = null) => {
    const params = plantId ? { plantId } : {};
    const response = await apiClient.get('/line', { params });
    return response.data;
  },

  /**
   * Get line by ID
   * @param {number} lineId - Line ID
   * @returns {Promise} Line details
   */
  getLineById: async (lineId) => {
    const response = await apiClient.get(`/line/${lineId}`);
    return response.data;
  },

  /**
   * Create a new line
   * @param {object} lineData - Line data
   * @returns {Promise} Created line
   */
  createLine: async (lineData) => {
    const response = await apiClient.post('/line', lineData);
    return response.data;
  },

  /**
   * Update line
   * @param {number} lineId - Line ID
   * @param {object} lineData - Updated line data
   * @returns {Promise} Updated line
   */
  updateLine: async (lineId, lineData) => {
    const response = await apiClient.post(`/line/update/${lineId}`, lineData);
    return response.data;
  },

  /**
   * Delete line
   * @param {number} lineId - Line ID
   * @returns {Promise} Deletion result
   */
  deleteLine: async (lineId) => {
    const response = await apiClient.post(`/line/delete/${lineId}`);
    return response.data;
  },
};

export default lineService;

